import { adminApi } from './admin-api';
import type { AdminFilters, AdminVault, AdminVaultDetail, ApiResponse, PaginatedResponse, VaultStorageStats } from '@/types/admin.types';

export const adminVaultsService = {
  getAll: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminVault>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
    const response = await adminApi.get(`/admin/vaults?${params.toString()}`);
    return response.data;
  },

  getById: async (uuid: string): Promise<ApiResponse<AdminVaultDetail>> => {
    const response = await adminApi.get(`/admin/vaults/${uuid}`);
    return response.data;
  },

  suspend: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/vaults/${uuid}/suspend`);
    return response.data;
  },

  activate: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/vaults/${uuid}/activate`);
    return response.data;
  },

  getStorageStats: async (): Promise<VaultStorageStats> => {
    const response = await adminApi.get('/admin/vaults/storage');
    return response.data;
  },
};
